<!-- 代码结果流程：
    1、初始化图标对象 initChart
	2、获取数据 getData
	3、处理数据更新图表 updateChart
	4、分辨率适配 screenAdapter
	
	图表基本功能实现： 1、数据获取  2、数据处理  3、图表的设置
	
-->

<template>
	<div class="com-container">
		<div class="com-chart" ref="trend_ref"></div>
		<!-- 
		    iconfont 的样式 是在main.js 中引入了 import './assets/font/iconfont.css'  【 src -> assets -> font -> iconfont.css】
			<span class="iconfont">&#xe6ef;</span> ==> 搞出左箭头 但是在右下角 被图表挡住 所以下面用了 arr-left 样式
		 -->
	<!-- 	<span class="iconfont arr-left" @click="toLeft" :style="comStyle">&#xe6ef;</span>
	    <span class="iconfont arr-right" @click="toRight" :style="comStyle">&#xe6ed;</span> -->
		<span class="arr-left " @click="toLeft" :style="comStyle" ><</span>
		<span class="arr-right " @click="toRight" :style="comStyle"   >></span>
	 

		<!-- 标题  catName 是计算属性  -->
		<span class="cat-name" :style="comStyle">{{ catName }}</span>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				chartInstane: null, // echart实例对象
				// allData: null, // 从服务器中获取的所有数据
				titleFontSize: 0,
				allData: [{
						"name": "女装",
						"children": [{
								"name": "裙装",
								"value": 56202,
								"children": [{
										"name": "套装裙",
										"value": 10281
									},
									{
										"name": "A字裙",
										"value": 22331
									},
									{
										"name": "复古连衣裙",
										"value": 23590
									}
								]
							},
							{
								"name": "女士上衣",
								"value": 42013,
								"children": [{
										"name": "格子衬衫",
										"value": 7896
									},
									{
										"name": "雪纺衫",
										"value": 10422
									},
									{
										"name": "polo衫",
										"value": 23695
									}
								]
							},
							{
								"name": "外套",
								"value": 210282,
								"children": [{
										"name": "牛仔外套",
										"value": 87330
									},
									{
										"name": "针织外套",
										"value": 65770
									},
									{
										"name": "风衣外套",
										"value": 57182
									}
								]
							},
							{
								"name": "裤装",
								"value": 168203,
								"children": [{
										"name": "工装裤",
										"value": 68203
									},
									{
										"name": "阔腿裤",
										"value": 50000
									},
									{
										"name": "牛仔裤",
										"value": 50000
									}
								]
							},
							{
								"name": "特色类目",
								"value": 40292,
								"children": [{
										"name": "大码女装",
										"value": 292
									},
									{
										"name": "旗袍",
										"value": 10000
									},
									{
										"name": "礼服",
										"value": 10000
									}
								]
							},
							{
								"name": "童装",
								"value": 20313,
								"children": [{
										"name": "童衣",
										"value": 5000
									},
									{
										"name": "童裤子",
										"value": 15313
									}
								]
							}
						]
					},
					{
						"name": "手机数码",
						"children": [{
								"name": "手机",
								"value": 201023,
								"children": [{
										"name": "拍照手机",
										"value": 1023
									},
									{
										"name": "游戏手机",
										"value": 40000
									},
									{
										"name": "全面屏手机",
										"value": 160000
									}
								]
							},
							{
								"name": "手机配件",
								"value": 103735,
								"children": [{
										"name": "手机壳",
										"value": 3735
									},
									{
										"name": "手机贴膜",
										"value": 70000
									},
									{
										"name": "创意配件",
										"value": 30000
									}
								]
							},
							{
								"name": "摄影摄像",
								"value": 83834,
								"children": [{
										"name": "单反相机",
										"value": 3834
									},
									{
										"name": "微单",
										"value": 50000
									},
									{
										"name": "镜头",
										"value": 30000
									}
								]
							},
							{
								"name": "影音娱乐",
								"value": 68384,
								"children": [{
										"name": "耳机/耳麦",
										"value": 30000
									},
									{
										"name": "音箱/音响",
										"value": 8384
									},
									{
										"name": "麦克风",
										"value": 30000
									}
								]
							},
							{
								"name": "数码配件",
								"value": 45038,
								"children": [{
										"name": "存储卡",
										"value": 10000
									},
									{
										"name": "三脚架/云台",
										"value": 5038
									},
									{
										"name": "机身附件",
										"value": 30000
									}
								]
							},
							{
								"name": "智能设备",
								"value": 90382,
								"children": [{
										"name": "智能手环",
										"value": 382
									},
									{
										"name": "智能家居",
										"value": 60000
									},
									{
										"name": "无人机",
										"value": 30000
									}
								]
							},
							{
								"name": "其他",
								"value": 10201,
								"children": [{
										"name": "运营商",
										"value": 10000
									},
									{
										"name": "电子教育",
										"value": 201
									}
								]
							}
						]
					},
					{
						"name": "美妆护肤",
						"children": [{
								"name": "面部护肤",
								"value": 430291,
								"children": [{
										"name": "乳液/面霜",
										"value": 30291
									},
									{
										"name": "洁面",
										"value": 100000
									},
									{
										"name": "面膜",
										"value": 300000
									}
								]
							},
							{
								"name": "彩妆",
								"value": 80284,
								"children": [{
										"name": "口红",
										"value": 60284
									},
									{
										"name": "粉底液",
										"value": 10000
									},
									{
										"name": "眉笔/眉粉",
										"value": 10000
									}
								]
							},
							{
								"name": "男士护肤",
								"value": 40294,
								"children": [{
										"name": "洁面",
										"value": 10294
									},
									{
										"name": "剃须",
										"value": 5000
									},
									{
										"name": "护肤套装",
										"value": 25000
									}
								]
							},
							{
								"name": "美妆工具",
								"value": 50939,
								"children": [{
										"name": "化妆棉",
										"value": 10939
									},
									{
										"name": "化妆刷",
										"value": 10000
									},
									{
										"name": "双眼皮贴",
										"value": 30000
									}
								]
							},
							{
								"name": "其他",
								"value": 10921,
								"children": [{
										"name": "香水",
										"value": 921
									},
									{
										"name": "当季主推",
										"value": 10000
									}
								]
							}
						]
					}
				],
				currentIndex: 0, // 当前展现出来的一级分类， 通过左右箭头来改变 currentIndex 的值
			}
		},
		mounted() {
			this.initChart()
			this.getData()
			window.addEventListener('resize', this.screenAdapter) // 分辨率的适配
			this.screenAdapter() // 主动调一次各种尺寸的计算
		},
		destroyed() {
			window.removeEventListener('resize', this.screenAdapter) // 取消监听
		},
		computed: {
			catName() {
				if (!this.allData) {
					return ''
				} else {
					return this.allData[this.currentIndex].name
				}
			},
			comStyle () {
			  return {
			    fontSize: this.titleFontSize + 'px',
			    // color: getThemeValue(this.theme).titleColor
			  }
			},
			// ...mapState(['theme'])
		},
		methods: {
			initChart() { // 初始化实例对象的方法
				this.chartInstane = this.echarts.init(this.$refs.trend_ref, 'chalk')
				const initOption = {
					title: { // 标题
						text: '▎ 热销商品的占比',
						left: 20,
						top: 20
					},
					legend: { // 图例
						top: '15%',
						icon: 'circle'
					},
					tooltip: { // 工具提示：当鼠标移动圆饼部分块中，会提示该块的数量值
						show: true,
						formatter: arg => { // 设置工具提示的文字内容  formatter可以写死成固定值比如：  formatter: '哈哈' 也可写成箭头函数，箭头函数的返回值就是提示的值
							// console.log(arg)  // arg.name 扇区的名字 ； arg.value  值；   arg.percent 百分比；
							const thirdCategory = arg.data.children
							// 计算出所有三级分类的数值总和
							let total = 0
							thirdCategory.forEach(item => {
								total += item.value
							})
							let retStr = ''
							thirdCategory.forEach(item => {
								// ` ` 模板字符串
								//  ${ parseInt(item.value / total * 100)
								retStr += `
					              ${ item.name }:${ (item.value / total * 100 ).toFixed(2) + '%' }
					              <br/>
					              `
							})
							return retStr
						}
					},
					series: [{
						type: 'pie',
						label: {
							show: false // 圆饼默认的线条与指示文字不显示
						},
						emphasis: { // 饼图处于高亮状态（选中状态）的样式
							label: {
								show: true
							},
							labelLine: {
								show: false
							}
						}
					}]
				}
				this.chartInstane.setOption(initOption)
			},
			getData() {
				// this.getRequest('/work_log/header_index1').then(resp => {
				// 	if (resp) {
				// 		this.allData = resp.data
				this.updateChart() // 更新图表
				// 	}
				// })
			},
			updateChart() { //处理数据  更新数据
				//    const legendData = this.allData[0].children.map(item => { //图例数据 返回是个数组  
				//    	return   item.name
				//    })

				const legendData = this.allData[this.currentIndex].children.map(item => { //图例数据 返回是个数组  
					return item.name
				})

				const seriesData = this.allData[this.currentIndex].children.map((item) => { // 饼图数据 返回是对象数组
					return {
						name: item.name,
						value: item.value,
						children: item.children //增加这项原因是为了 tooltip 的formatter 展现3级分类的数据
					}
				})
				const dataOption = {
					legend: {
						data: legendData
					},
					series: [{
						data: seriesData
					}]
				}
				this.chartInstane.setOption(dataOption)
			},
			screenAdapter() {
				this.titleFontSize = this.$refs.trend_ref.offsetWidth / 100 * 3.6       // 若 还需要通过计算属性来调整两个箭头的大小，所以用 this.titleFontSize
				// const titleFontSize = this.$refs.trend_ref.offsetWidth / 100 * 3.6   // 若只是通过 adapterOption 取设置自动适配就用这个
				const adapterOption = {
					title: {
						textStyle: {
							fontSize: this.titleFontSize //标题文字的大小
						}
					},
					legend: { // 图例的大小以及图例文字的大小
						itemWidth: this.titleFontSize,
						itemHeight: this.titleFontSize,
						itemGap: this.titleFontSize / 2,
						textStyle: {
							fontSize: this.titleFontSize / 2
						}
					},
					series: [{
						radius: this.titleFontSize * 4.5,  //饼图的大小时通过饼图的半径来决定的
						center: ['50%', '60%']   //饼图的位置，圆心点的位置  60%代表Y轴向下一点。
					}]
				}
				this.chartInstane.setOption(adapterOption)
				this.chartInstane.resize()
			},
			toLeft() {
				this.currentIndex--
				if (this.currentIndex < 0) {
					this.currentIndex = this.allData.length - 1
				}
				this.updateChart()
			},
			toRight() {
				this.currentIndex++
				if (this.currentIndex > this.allData.length - 1) {
					this.currentIndex = 0
				}
				this.updateChart()
			}
		}
	}
</script>

<style>
	.arr-left {
		position: absolute;
		left: 10%;
		top: 50%;
		
		transform: translateY(-50%);
		/* transform:rotate(180deg); */
		cursor: pointer;
		/* 鼠标移到上面变指示手 */
		color: white;
	}

	.arr-right {
		position: absolute;
		right: 10%;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		color: white;
	}

	.cat-name {
		position: absolute;
		left: 80%;
		bottom: 20px;
		color: white;
	}
</style>
